module.exports = __webpack_public_path__ + "static/media/2.b95dce99.png";